<template>
	<div class="wholeMsg">
		<div class="nav" style="border: none;">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>整装整租</span>
			<div></div>
		</div>
		<div class="backgd"></div>
		<!-- 订单信息 -->
		<div class="container">
			<div class="list">
				<div class="list-header">
					<div>订单信息</div>
					<div>
						<span>{{list.create_time}}</span>
						<span v-if="list.state == 0">付款确认中</span>
						<span v-if="list.state == 1">已付款</span>
					</div>
				</div>
				<div class="list-main">
					<!-- 					<div>
						<span> 房屋面积: {{list.house_area}}M²</span>&nbsp;&nbsp;
						<span v-if="list.lease_year == 1">租赁期限：12个月</span>
						<span v-if="list.lease_year == 2">租赁期限：24个月</span>
						<span v-if="list.lease_year == 3">租赁期限：36个月</span>
					</div> -->
					<div>
						<span> 月租金: ¥{{list.month_total}}/M²</span>&nbsp;&nbsp;<span>总价：</span><span class="totals">¥{{list.total}}</span><span
						 class="mortgage">(含可退押金¥{{list.mortgage_total}})</span>
					</div>
				</div>
				<div class="list-foot">
					<div>订单编号：{{list.order_number}}</div>
					<div v-if="list.is_channel == 1">付款方式：对公转账</div>
				</div>
			</div>
			<!-- 联系信息 -->
			<div class="userMsg">
				<div class="user-header">联系信息</div>
				<div class="user-main">
					<div>联系人：{{list.real_name}}</div>
					<div>联系电话：{{list.tel}}</div>
					<div>省市区：{{list.province}}</div>
					<div>项目地址：{{list.address}}</div>
					<div>备注信息：{{list.order_message}}</div>
				</div>
			</div>
			<!-- 配置信息 -->
			<div class="deploy">
				<div class="user-header">需求配置单</div>
				<div style="height: 0.625rem;"></div>
				<div class="deploy-main">
					<div style="display: flex; justify-content: space-between; margin: 10px 0;" v-for="item in list.sublist">
						<div style="width: 70%;">{{item.title}}</div>
						<div>X{{item.num}}</div>
					</div>
				</div>
			</div>
			<div  class="deploy" v-if="list.state != 1" style="background-color: #F2F2F2; margin-top: 0; color: #999999;"  @click="dellist">
				<div>取消订单</div>
			</div>
			<!-- 付款按钮 -->
			<div class="btn" v-if="list.state != 1" style="display: flex; justify-content: space-between; width: 88%; margin: 2rem auto; margin-bottom: 0; line-height: 1.875rem;">
				<van-button style="width: 45%;" color="#F1452F" round size="small" @click="hetongxiazai">下载合同</van-button>
				<van-button style="width: 45%;" color="#F1452F" round size="small" @click="show=true">去付款</van-button>
			</div>
			<div class="btn" style="margin: 2rem auto; margin-bottom: 0;" v-else>
				<van-button color="#F1452F" round size="small" @click="hetongxiazai">下载合同</van-button>
			</div>
			<div style="height: 3rem;"></div>
			<!-- 选择支付方式 -->
			<van-popup v-model="show" position="bottom">
				<van-panel class="payment">
					<div slot="header" class="payment_header">
						支付方式
					</div>
					<div class="payment_content">
						<van-radio-group v-model="radio">
							<van-cell-group>
								<van-cell title="微信支付" clickable @click="radio='1'">
									<div slot="icon" class="payment_icon">
										<img src="../../../assets/wx.png" alt="">
									</div>
									<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
								</van-cell>
								<van-cell title="支付宝支付" clickable @click="radio='2'">
									<div slot="icon" class="payment_icon">
										<img src="../../../assets/zfb.png" alt="">
									</div>
									<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
								</van-cell>
							</van-cell-group>
						</van-radio-group>
						<div class="pays_btn">
							<button @click="nextPay">确定</button>
						</div>
					</div>
				</van-panel>
			</van-popup>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: {},
				show: false,
				radio: '1'
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Whole_Order/wholeOrderInfo', {
				order_number: this.$route.query.number
			}).then((res) => {
				if (res.data.code == 2) {
					this.list = res.data.data;
					if (this.list.order_message == '') {
						this.list.order_message = '暂无备注信息'
					}
				}
			}).catch((err) => {
				console.log(err);
			})
		},
		methods: {
			hetongxiazai() {
				var a = ''
				if (this.list.state == 0) {
					a = 1
				} else {
					a = 2
				}
				this.$router.push({
					path: '/contractPreview',
					query: {
						order_number: this.$route.query.number,
						type: a,
						way: 1
					}
				})
			},
			// 删除订单
			dellist() {
				var t = this
				this.$dialog.confirm({
					title: '订单取消后将导致您的订单消失',
					message: '您确定要取消订单吗？'
				}).then(() => {
					if (t.list.is_channel != 1) {
						this.$axios.post(baseUrl + '/mobile/Whole_Order/wholeOrderDel', {
							id: this.list.id,
						}).then(res => {
							t.$toast("订单取消成功");
							t.back();
						}).catch((err) => {
							console.log(err);
						})
					} else {
						t.$toast("此订单已完成无法取消");
					}
				}).catch(() => {});
			},
			//继续支付
			nextPay() {
				if (this.radio == '1') {
					window.location.href = baseUrl + '/mobile/Pay/wholeWapWxPay?out_trade_no=' + this.$route.query.number;
				} else if (this.radio == '2') {
					window.location.href = baseUrl + '/mobile/Pay/wholeWapPay?out_trade_no=' + this.$route.query.number;
				} else {
					this.$toast('暂不支持');
				}
			}
		},
	}
</script>

<style scoped>
	@import 'wholeMsg.css';
</style>



// WEBPACK FOOTER //
// src/components/home/whole/wholeMsg.vue